// filepath: /haihuan-laundry-admin/haihuan-laundry-admin/src/config/settings.ts
export const settings = {
  appName: '海环洗涤管理后台',
  apiBaseUrl: 'http://localhost:3000/api', // Mock API base URL
  defaultLanguage: 'zh-CN',
  theme: {
    primaryColor: '#409EFF',
    secondaryColor: '#67C23A',
  },
  pagination: {
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
  },
  dateFormat: 'YYYY-MM-DD',
  timeFormat: 'HH:mm:ss',
};
